import { Routes } from 'react-router-dom';
////////////////////////////////////////////////////////////////////
import { Nav, Toaster } from '@/app/shared/components';
import { appRoutes } from '@/routes';
import './Game.css';
export const Game: React.FC = () => {
	/*********************
	// #region States
	**********************/

	/*********************
	// #region Observables
	**********************/

	/*********************
	// #region Template
	**********************/

	return (
		<>
			<Routes>{appRoutes}</Routes>
			<Nav />
			<Toaster
				position="top-center"
				toastOptions={{
					classNames: {
						error: 'text-red-400 bg-customer-950/80',
						success: 'text-green-400 bg-customer-950/80',
						warning: 'text-yellow-400 bg-customer-950/80',
						info: 'text-blue-400/50 bg-customer-950/80',
						loading: 'text-white bg-customer-950/80',
					},
				}}
			/>
		</>
	);
};
